import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import './Pending.css';

const Pending = ({ count = 0 }) => {
    return (
        <div className="pending-card">
            <div className="pending-header">
                <span className="pending-title">Pending</span>
                <FontAwesomeIcon icon={faClock} className="pending-icon" />
            </div>
            <span className="pending-count">{count}</span>
        </div>
    );
};

export default Pending;
